
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import HiddenHorizontalScrollbar from '@/components/HiddenHorizontalScrollbar.vue';

import { SingleStepSportEvent } from '@/@types/graphql-types';
import type { WebLocale } from '@/enums/web-locale';
import { contextSportIs, SingleStepContext } from '@/helpers/sports/config';

const Language = namespace('language');

@Component({
	name: 'SingleStepEventDetails',
	components: { HiddenHorizontalScrollbar },
})
export default class SingleStepEventDetails extends Vue {
	@Prop({ default: '' }) kickoffDate: string;
	@Prop({ required: true }) context: SingleStepContext;
	@Prop({ required: true }) event: SingleStepSportEvent;

	@Language.State webLocale: WebLocale;

	get rows() {
		const rows = [
			{
				key: this.$t('SPORTS_WEBAPP_KICKOFF_DATE'),
				value: this.kickoffDate,
				icon: `/${ASSETS_DIR}/img/sports/icons/calendar.svg`,
			},
			{
				key: this.$t('SPORTS_WEBAPP_STADIUM'),
				value: this.event.content?.venue?.name,
				icon: `/${ASSETS_DIR}/img/sports/icons/stadium.svg`,
			},
			{
				key: this.$t('SPORTS_WEBAPP_COMPETITION'),
				value: this.event?.competition?.content.name,
				icon: `/${ASSETS_DIR}/img/sports/icons/champions_league_cup.svg`,
			},
		].filter(row => row.value);

		const { start, end, isSwitched } = this.context.getCompetitors(this.event, this.webLocale);

		const homeAndAwayCompetitors = [
			{
				key: isSwitched ? this.$t(`SPORTS_WEBAPP_AWAY_TEAM`) : this.$t(`SPORTS_WEBAPP_HOME_TEAM`),
				value: start.map(team => team.name).join(' / '),
				icon: `/${ASSETS_DIR}/img/sports/icons/home_team.svg`,
			},
			{
				key: isSwitched ? this.$t(`SPORTS_WEBAPP_HOME_TEAM`) : this.$t(`SPORTS_WEBAPP_AWAY_TEAM`),
				value: end.map(team => team.name).join(' / '),
				icon: `/${ASSETS_DIR}/img/sports/icons/away_team.svg`,
			},
		];

		const numberedPlayersCompetitors = [
			{
				key: this.$t('SPORTS_WEBAPP_TEAM_X', { number: 1 }),
				value: start[0].name,
				icon: `/${ASSETS_DIR}/img/sports/icons/home_team.svg`,
			},
			{
				key: this.$t('SPORTS_WEBAPP_TEAM_X', { number: 2 }),
				value: end[0].name,
				icon: `/${ASSETS_DIR}/img/sports/icons/away_team.svg`,
			},
		];

		return rows.concat(contextSportIs.esports(this.context) ? numberedPlayersCompetitors : homeAndAwayCompetitors);
	}
}
